import {Component, Inject, OnInit,   ViewChild, ElementRef } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EndoDiagnosisDataModel} from '../../models/endo-diagnosis-data.model';
import * as console from "console";
import {TdoEnumSelectComponent} from "../../../../../../tdo-controls/common/tdo-enum-select/tdo-enum-select.component";

@Component({
  selector: 'app-diagnosis-soft-tissue-dialog',
  templateUrl: './diagnosis-soft-tissue-dialog.component.html',
  styleUrls: ['./diagnosis-soft-tissue-dialog.component.scss']
})
export class DiagnosisSoftTissueDialogComponent implements OnInit {

  @ViewChild("idenumDiagSTEFace") idenumDiagSTEFace: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTENeck") idenumDiagSTENeck: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTELips") idenumDiagSTELips: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTETongue") idenumDiagSTETongue: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEFloorOfMouth") idenumDiagSTEFloorOfMouth: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEAlveolarMucosa") idenumDiagSTEAlveolarMucosa: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEHardPlate") idenumDiagSTEHardPlate: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTESoftPlate") idenumDiagSTESoftPlate: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEGingiva") idenumDiagSTEGingiva: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTELingAttachGingiva") idenumDiagSTELingAttachGingiva: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEBuccalAttachGingiva") idenumDiagSTEBuccalAttachGingiva: TdoEnumSelectComponent;
  @ViewChild("idenumDiagSTEOropharynx") idenumDiagSTEOropharynx: TdoEnumSelectComponent;





  isChangeMade: boolean = false;

  constructor(private dialogRef: MatDialogRef<DiagnosisSoftTissueDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: EndoDiagnosisDataModel) { }

  ngOnInit(): void {
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close(this.isChangeMade);
  }

  setSoftTissueDefault() {

    try {


      this.data.cest_STE_enumDiagSTEFaceID = this.idenumDiagSTEFace.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTENeckID = this.idenumDiagSTENeck.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTELipsID = this.idenumDiagSTELips.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTETongueID = this.idenumDiagSTETongue.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTEFloorOfMouthID = this.idenumDiagSTEFloorOfMouth.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTEAlveolarMucosaID = this.idenumDiagSTEAlveolarMucosa.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTEHardPlateID = this.idenumDiagSTEHardPlate.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTESoftPlateID = this.idenumDiagSTESoftPlate.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTEGingivaID = this.idenumDiagSTEGingiva.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTELingAttachGingivaID = this.idenumDiagSTELingAttachGingiva.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTEBuccalAttachGingivaID = this.idenumDiagSTEBuccalAttachGingiva.validValueItems[0].ValidValueItemId;
      this.data.cest_STE_enumDiagSTEOropharynxID = this.idenumDiagSTEOropharynx.validValueItems[0].ValidValueItemId;
      this.isChangeMade = true;


    }
    catch (e)
    {

      let z= e;



    }


  }
}
